//import React from 'react'

// not display list of user, tell user to download app to use lists
import RedirectAppStore from 'pages/redirectAppStore'

export default RedirectAppStore
